<template>
    <div >
            <el-card class="detail-card">
                <ul>
                    <li>
                        <p  v-show="status=='服务台'&&canIEdit==true"> <el-button type="primary" @click="appointFn('accept')">变更工单接收</el-button></p>
                        <p v-show="status=='CAB审批'&&canIEdit==true"> <el-button type="primary"  @click="appointFn('cab-approved')">CAB审批通过</el-button></p>
                        <p v-show="status=='CAB审批'&&canIEdit==true"><el-button type="primary"  @click="appointFn('cab-rejected')">CAB审批不通过</el-button></p>
                        <p v-show="status=='CAB审批'&&canIEdit==true" ><el-button type="primary" @click="appointFn('all-approved')">CAB全部通过</el-button></p>
                        <p v-show="status=='制定解决方案'&&canIEdit==true" > <el-button type="primary" @click="appointFn('solution')">制定解决方案</el-button></p>
                        <p v-show="status=='实施解决方案'&&canIEdit==true"> <el-button type="primary"  @click="appointFn('complete')">变更完成</el-button></p>
                        <p v-show="status=='实施解决方案'&&canIEdit==true" ><el-button type="primary" @click="appointFn('fail')">变更失败</el-button></p>
                        <p v-show="status=='观察中'&&canIEdit==true" ><el-button type="primary" @click="appointFn('finish-observer')">观察完成</el-button></p>
                        <p v-show="status=='服务台'&&recoverEdit==true"><el-button type="primary" @click="recallEvent('withdraw')">撤回</el-button></p>
                        <p v-show="status !='变更完成'&&status!='拒绝'&&status!='取消'&&status!='变更失败'&&status!='创建'&&canIEdit==true"><el-button type="primary"  @click="appointFn('rebut')">驳回</el-button></p>
                        <p v-show="status=='创建'&&canIEdit==true"><el-button type="primary"  @click="deliver('submission')">提交</el-button></p>
                        <p  v-show="status!='服务台'&&status!='变更完成'&&status!=='变更失败'&&status!='拒绝'&&status!='取消'&&canIEdit==true"> <el-button type="primary" @click="appointFn('transfer')" v-w-role="'ITSM-0252'">转交</el-button></p>
                            <!--拒绝-->
                        <p v-show="status!='变更完成'&&status!='拒绝'&&status!='取消'&&status!='变更失败'&&status!='创建'&&canIEdit==true"> <el-button type="primary" @click="appointFn('reject')" >拒绝</el-button></p>
                            <!--取消-->
                        <p v-show="canCancel&&status!='变更完成'&&status!='取消'&&status!='拒绝'&&status!='变更失败'&&status!='创建'&&canIEdit==true"> <el-button type="primary"  @click="appointFn('cancel') ">取消</el-button></p>
                        <!--编辑-->
                        <p v-show="status!='变更完成'&&status!='取消'&&status!='拒绝'&&status!='变更失败'&&canIEdit==true"><el-button type="primary" @click="toChangeUpdate">编辑</el-button></p>
                            <router-link :to="{ path: '/flowChart',query:{ serialNumber:serialNumber}}">
                                <el-button type="primary">流程跟踪</el-button>
                            </router-link>
                    </li>
                    <li>
                        <el-row >
                            <router-link  :to="{ path:'/eventAdd',query: { parentNumber:serialNumber,callback:getDetail } }">
                                <el-button type="primary" v-w-role="'ITSM-0222'">提交为事件</el-button>
                            </router-link>
                            <router-link  :to="{ path:'/problemAdd',query: { parentNumber:serialNumber,callback:getDetail } }">
                                <el-button type="primary" v-w-role="'ITSM-0223'">提交为问题</el-button>
                            </router-link>
                            <router-link  :to="{ path:'/changeAdd',query: { parentNumber:serialNumber,callback:getDetail } }">
                                <el-button type="primary" v-w-role="'ITSM-0224'">提交为变更</el-button>
                            </router-link>
                            <router-link  :to="{ path:'/deployAdd',query: { parentNumber:serialNumber,callback:getDetail } }">
                                <el-button type="primary" v-w-role="'ITSM-0225'">提交为发布</el-button>
                            </router-link>
                        </el-row>
                    </li>

                </ul>
                <el-row>
                    <el-col :span="6"><label>编号：</label>{{ detail.serialNumber }}--{{status}}</el-col>
                    <el-col :span="18"><label>标题：</label>{{ detail.title }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="6"><label>请求人：</label>{{ detail.requester&&detail.requester.name }}</el-col>
                    <el-col :span="18"><label>创建时间：</label>{{ detail.createTime }}</el-col>
                </el-row>
            </el-card>
            <div class="tab-card">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane :label="item.name" :name="item.index" v-for="item in tabViews" :key="item.index">
                        <div v-loading="loading" v-if="loading" style="width:100%;height:300px;"></div>
                        <keep-alive v-if="!loading">
                            <component :is="currentView"
                                       :detail="detail"
                                       :status="status"
                                       :serialNumber="serialNumber"
                                       :callback="getDetail"
                                       :companyList="companyList"
                                       :eventList="eventList"
                                       :problemList="problemList"
                                       :changeList="changeList"
                                       :deployList="deployList"
                                       :hotFAQ="hotFAQ"
                            ></component>
                        </keep-alive>
                    </el-tab-pane>
                </el-tabs>
            </div>
    </div>
</template>

<script>
    import commonService from "../../services/common.service"
    import services from "./change.service";
    import ueditor from "../../components/ueditor.vue"
    import detailForm from "./detailComponents/detailForm.vue";                     //表单明细
    import detailHandle from "./detailComponents/detailHandle.vue";
    import ImplementPlan from "../common/detail/detailImplementPlan"                //实施方案
    import WorkHours from "../common/detail/detailWorkHours.vue";                  // 工时/成本
    import SolveProject from "../common/detail/detailSolveProject.vue";            // 解决方案
    import HistoricRecords from "../common/detail/detailHistoricRecords.vue";      // 历史记录
    import HistoricNews from "../common/detail/detailHistoricNews.vue";            // 历史消息
    import detailKnowledge from "../common/detail/detailKnowledge.vue";            // 推荐知识
    import RelevancyEvent from "../common/detail/detailRelevancyEvent.vue";        // 关联事件
    import RelevancyQue from "../common/detail/detailRelevancyQue.vue";            // 关联问题
    import RelevancyChange from "../common/detail/detailRelevancyChange.vue";      // 关联变更
    import RelevancyIssue from "../common/detail/detailRelevancyIssue.vue";        // 关联发布
    import RelevancyConfig from "../common/detail/detailRelevancyConfig.vue";      // 关联配置项
    import RelevancyService from "../common/detail/detailRelevancyService.vue";    // 关联服务

    export default {

        data() {
            return {
                detail:{},
                companyList:[],
                eventList:[],
                problemList:[],
                changeList:[],
                deployList:[],
                status:"",   // 状态
                index:0,
                loading:true,
                activeName:"detailForm",
                hotFAQ:[],
                tabViews:[
                    { name:"表单明细",index:"detailForm"},
                    { name:"处理明细",index:"detailHandle"},
                    {name:"实施方案",index:"ImplementPlan"},
                    { name:"工时",index:"WorkHours"},      //
                    { name:"解决方案",index:"SolveProject"},  //
                    { name:"历史记录",index:"HistoricRecords"},  //
                    { name:"历史消息",index:"HistoricNews"}, //
                    { name:"推荐知识",index:"detailKnowledge"},//
                    { name:"关联事件",index:"RelevancyEvent"},//
                    { name:"关联问题",index:"RelevancyQue"},//
                    { name:"关联变更",index:"RelevancyChange"},//
                    { name:"关联发布",index:"RelevancyIssue"},//
                    { name:"关联配置项",index:"RelevancyConfig"},//
                    { name:"关联服务",index:"RelevancyService"},//

                ],
                canCancel:false,
                canIEdit: false,
                recoverEdit:false,
                // submitBtn:false,
                // allowBtn:false,
            }

        },
        components:{
            ueditor,
            detailForm,
            detailHandle,
            ImplementPlan,
            WorkHours,
            SolveProject,
            HistoricRecords,
            HistoricNews,
            detailKnowledge,
            RelevancyEvent,
            RelevancyQue,
            RelevancyChange,
            RelevancyIssue,
            RelevancyConfig,
            RelevancyService
        },
        computed:{
            currentView(){
                return this.tabViews[this.index].index;
            },
            query:function () {
                return this.$route.query
            },
            serialNumber:function () {
                return this.query.serialNumber
            },
            dictionary(){
                return this.$store.state.dictionary;
            },
            changeStatus(){
                return this.dictionary.change_status;
            },
            // 事件分类id
            eventType(){
                return this.$store.state.caseType.event;
            },
            // 问题分类id
            problemType(){
                return this.$store.state.caseType.problem;
            },
            // 变更分类id
            changeType(){
                return this.$store.state.caseType.change;
            },
            // 发布分类id
            deployType(){
                return this.$store.state.caseType.deploy;
            },
            user(){

                // return window.localStorage.getItem('name')
                return window.localStorage.getItem('internalUserid')
            },
            userCName(){

                return window.localStorage.getItem('name')
            },
            //登陆的用户角色类型:超管、服务台组、普通用户
            userRole(){
                return window.localStorage.getItem('userRole')
            },
        },
        watch:{
            '$route'(to,from){
                if (to.query.serialNumber != from.query.serialNumber){
                    this.sn = to.query.serialNumber
                    this.getDetail()
                }
            }
        },
        created() {
            if (this.$route.query){
                // console.log(this.$route.query);
                this.sn = this.$route.query.serialNumber
            }
            this.getDetail();
            this.getCompanyList();
            this.getEventList();
            this.getProblemList();
            this.getChangeList();
            this.getDeployList();
        },
        methods: {
            getDetail(){
                if (this.userRole=='super'){
                    this.canIEdit=true
                    this.recoverEdit = true
                }else{
                    this.canIEdit=false
                    this.recoverEdit = false
                }
                services.detail({serialNumber:this.serialNumber}).then(res => {
                    // console.log(res,'获取变更详情');
                    this.detail =  res;
                    if(JSON.stringify(res.wait_approve) !='{}'){
                        let data = {...res.wait_approve}
                        this.$store.commit('setWaitApprove', data)
                    }
                    res.requester.internalUserid&&res.requester.internalUserid == this.user?this.recoverEdit=true:''
                    res.currentHandler==this.userCName?this.canIEdit=true:''
                    this.status=this.getNameById(res.status,this.changeStatus)
                    if (this.status=='服务台'&&this.userRole=='reception'){
                        this.canIEdit=true
                    }
                    if (this.status=='创建'&& res.requester.internalUserid == this.user){
                        this.canIEdit=true
                    }
                    if (this.status=='服务台'&& res.requester.internalUserid == this.user){
                        this.recoverEdit=true
                    }
                    this.search();
                    // console.log(this.changeStatus);
                    //判断取消按钮是否能出现
                    this.canICancel()
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(()=>{
                    this.loading=false
                })
            },
            //判断取消按钮是否能出现
            canICancel(){
                // console.log('lalla');
                let username =window.localStorage.getItem('name')
                let createUser=this.detail.createUser
                let requester=this.detail.requester
                if (username==createUser){
                    this.canCancel=true
                }
            },
            // 获取所属公司列表
            getCompanyList(){
                commonService.companyList().then(res => {
                    this.companyList = res.list;
                })
            },
            // 获取事件分类
            getEventList(){
                commonService.categoryList(this.eventType.id).then(res => {
                    // console.log(res,'事件分类');
                    this.eventList = res;
                })
            },
            // 获取问题分类
            getProblemList(){
                commonService.categoryList(this.problemType.id).then(res => {
                    this.problemList = res;
                })
            },
            // 获取变更分类
            getChangeList(){
                commonService.categoryList(this.changeType.id).then(res => {
                    // console.log(res,'变更分类');
                    this.changeList = res;
                })
            },
            // 获取发布分类
            getDeployList(){
                commonService.categoryList(this.deployType.id).then(res => {
                    this.deployList = res;
                })
            },
            search(){//默认查询
                services.getKnowledgeList({"Query":this.detail.title,"pageIndex":1,"pageSize":5}).then(res=>{
                    this.hotFAQ = res.KnowledgeTable;
                })
            },
            //指派
            appointFn(val){
                this.$router.push({
                    path: '/changeAppoint',
                    name: "changeAppoint",
                    query: {
                        type:val,
                        serialNumber:this.serialNumber,
                        callback:this.getDetail,
                        changeType:this.detail.changeType,
                        status:this.status,
                        currentHandler:this.detail.currentHandler
                    }
                })
            },
            // 撤回
            recallEvent(val){
                this.$confirm('您确定要撤回吗?', '撤回', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    let params = {
                        serialNumber:this.serialNumber,
                        handle: val
                    }
                    commonService.changeHandle(params).then(res => {
                        this.$message({
                            type: 'success',
                            message: '撤回成功!'
                        });
                        this.getDetail()
                    }).catch(err => {
                        this.isSubmit=false
                        this.$message.error(err.message);
                    })

                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消撤回'
                  });
                });
            },
            //编辑
            toChangeUpdate(){
                this.$router.push({
                    path: '/changeAdd',
                    name: "changeAdd",
                    query: {
                        type:'edit',
                        serialNumber:this.serialNumber,
                        callback:this.getDetail
                    }
                })
            },
            deliver(text){
                this.openMessage('您确定要提交到服务台吗？', '确定', () => {
                    commonService.changeHandle({ handle:text,serialNumber:this.serialNumber }).then(res => {
                        this.$message.success("提交成功");
                        this.getDetail();
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                });
            },
            //处理完成
            openMessage(message, confirmText, doit) {
                this.$confirm(message, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: confirmText,
                    confirmButtonClass: 'confirmBtn'
                }).then(() => {
                    doit();
                })
            },
            handleClick(tab, event){
                this.index = tab.index;
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
    .zebra-item{
        span{
            padding-right: 10px;
        }
    }
    .el-button--mini{
        margin: 0 10px;
    }
</style>
